import React from 'react';
import { Eye, File, ChevronDown } from 'react-feather';
import { useToggle } from 'hooks';
import LESSON_STATES from 'constants/lesson_states';
import { routes } from 'constants/config';
import { Button, Popover } from 'ui';
import Dismissable from 'components/shared/dismissable';

const LessonPreviewButton = ({ lesson }) => {
  const isDraft = lesson.state === LESSON_STATES.DRAFT;
  const isNewVersionPending =
    lesson.state === LESSON_STATES.NEW_VERSION_PENDING;
  const previewUrl = isDraft
    ? routes.LESSON_OVERVIEW.PREVIEW_LESSON_DRAFT(lesson.id)
    : routes.LESSON_OVERVIEW.PREVIEW_LESSON(lesson.id);

  const [isPreviewDropdownVisible, toggleIsPreviewDropdownVisible] =
    useToggle();

  if (!isNewVersionPending) {
    return (
      <Button className="d-f jc-c ws-nw" target="_blank" url={previewUrl}>
        <span className="d-f ai-c">
          <Eye className="mr-8 c-midnight-50" size={20} />
          <span className="pl-8 pr-8">{t('lesson_overview.preview')}</span>
        </span>
      </Button>
    );
  }

  return (
    <Dismissable
      dismissCallback={() =>
        isPreviewDropdownVisible && toggleIsPreviewDropdownVisible()
      }
    >
      <Popover
        className="LessonOverviewLayout-mt-7"
        visible={isPreviewDropdownVisible}
        align="right"
        onClose={toggleIsPreviewDropdownVisible}
        activator={
          <Button
            className="d-f jc-c ws-nw"
            onClick={toggleIsPreviewDropdownVisible}
          >
            <span className="d-f ai-c">
              <span className="pl-8 pr-8">{t('lesson_overview.preview')}</span>
              <ChevronDown className="ml-8 c-midnight-50" size={20} />
            </span>
          </Button>
        }
      >
        <div className="h-ctch-ctc ff-ss ls-n z-10 bg-white LessonOverviewLayout-feather-dropdown-content">
          <a
            className="td-n"
            target="_blank"
            rel="noopener noreferrer"
            href={routes.LESSON_OVERVIEW.PREVIEW_LESSON(lesson.id)}
          >
            <li className="p-10 fz-16 d-f ai-c td-n c-p">
              <Eye className="mr-8 ml-12 mr-12 c-midnight-50" size={20} />
              {t('lesson_overview.preview_published')}
            </li>
          </a>
          <a
            className="td-n"
            target="_blank"
            rel="noopener noreferrer"
            href={routes.LESSON_OVERVIEW.PREVIEW_LESSON_DRAFT(lesson.id)}
          >
            <li className="p-10 fz-16 d-f ai-c td-n c-p">
              <File className="mr-8 ml-12 mr-12 c-midnight-50" size={20} />
              {t('lesson_overview.preview_draft')}
            </li>
          </a>
        </div>
      </Popover>
    </Dismissable>
  );
};
export default props => <LessonPreviewButton {...props} />;
